import { useLocation } from 'react-router-dom';

import { PATH } from '@constants';

import { AppsViewType } from '@components/Ui/Apps';

import { PlatformAppsTemplatesHeader } from './PlatformAppsTemplatesHeader';

export const PlatformAppsHeaderCenter: React.FC = () => {
  const { pathname } = useLocation();

  const header = (() => {
    switch (pathname) {
      case PATH.APPS:
        return <PlatformAppsTemplatesHeader />;
      case PATH.APPS_LEGACY:
        return <AppsViewType />;

      default:
        return null;
    }
  })();

  return <div className="ml-6 flex flex-1 items-center gap-6">{header}</div>;
};
